// src/hooks/useAssistantContext.js
import { useMemo } from "react";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import {
    selectEffectiveUser,
    selectEffectiveUserId,
} from "../../sous-profile/redux/selectors/sousProfileSelectors";

const readLS = (k) => {
    try {
        return localStorage.getItem(k) || Cookies.get(k);
    } catch {
        return null;
    }
};

export default function useAssistantContext(mode = "patient") {
    const doctor = useSelector((s) => s.doctor);
    const effectiveUser = useSelector(selectEffectiveUser);
    const effectiveUserId = useSelector(selectEffectiveUserId);

    const isDoctorMode = String(mode).toLowerCase() === "doctor";

    // ---- tokens (only for authenticated flag here) ----
    const patientToken = readLS("accessToken") || readLS("auth_token");
    const doctorToken =
        readLS("doctorToken") ||
        readLS("doctor_accessToken") ||
        readLS("doctor_auth_token") ||
        readLS("doctorAccessToken");

    // ---- ids / roles ----
    const patientId = effectiveUserId ?? readLS("id") ?? null;
    const doctorId = doctor?.user?.id ?? doctor?.user?.doctorId ?? readLS("doctor_id") ?? null;

    const patientRole = effectiveUser?.role ?? readLS("role") ?? "patient";
    const doctorRole = doctor?.user?.role ?? readLS("doctor_role") ?? "doctor";

    const locale = navigator.language?.split("-")[0] || "fr";
    const currentRoute = typeof window !== "undefined" ? window.location.pathname : "/";

    const authenticated = isDoctorMode
        ? !!doctorToken || !!doctor?.user?.id
        : !!patientToken || !!effectiveUserId;

    const userId = isDoctorMode ? doctorId : patientId;
    const role = isDoctorMode ? doctorRole : patientRole;

    return useMemo(
        () => ({
            locale,
            currentRoute,
            userId,
            role,
            authenticated,
            mode: isDoctorMode ? "doctor" : "patient",
        }),
        [locale, currentRoute, userId, role, authenticated, isDoctorMode]
    );
}
